// extracted by mini-css-extract-plugin
export var container = "index-module--container--eh-Zn";
export var link = "index-module--link--feYIK";
export var subtitle = "index-module--subtitle--zMfV6";
export var title = "index-module--title--D+Qxl";